import React, { FC } from 'react'
import HeaderConnector, { ConnectorProps as HeaderProps } from '../../connectors/Header'

const HeaderTitle: FC<HeaderProps> = ({ title, searchQuery }) => {
  const seoTitle = searchQuery ? `Results for "${searchQuery}"` : title

  return (
    <div data-type='seo-title-container'>
      <h1 className='defaultTypographyH3'>{seoTitle}</h1>
    </div>
  )
}

export default HeaderConnector(HeaderTitle)
